module.exports = __webpack_public_path__ + "ws.6d92b2e4.svg";